import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Card,
	CardActions,
	CardContent,
	CardHeader,
	Grid,
	Divider,
	colors, List, ListItem, ListItemText, Typography,
	IconButton,
	Input,
	Paper,
	Tooltip,
} from '@mui/material';

import SendIcon from '@mui/icons-material/Send';

import { AddComment } from '../../../../../actions/TicketsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(1),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	paper: {
		flexGrow: 1,
		padding: theme.spacing(0.5, 2),
	},
	input: {
		width: '100%',
	},
}));

const Comments = (props) => {
	const { className, ticketId, comments, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const [commentValue, setCommentValue] = useState('');
	const user = useSelector(state => state.session.user);

	const _handleCommentInputChange = (event) => {
		let comment = event.target.value;
		comment = comment.trim();
		if (comment.length >= 0) {
			setCommentValue(event.target.value);
		}
	};

	const _postComment = () => {
		dispatch(AddComment(ticketId, user.id, commentValue));
		setCommentValue('');
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<CardHeader title="Comments" />
			<Divider />
			<CardContent style={{ maxHeight: '35em', overflowY: 'scroll' }}>
				<Grid container spacing={4}>
					<Grid item md={12} xs={12}>
						{comments && (
							<List>
								{comments.length > 0 ? comments.map(comment => (
									<>
										<ListItem alignItems="flex-start">
											<ListItemText
												primary={(
													<>
														<Typography
															component="span"
															color="textPrimary"
															style={{ fontWeight: 'bold' }}
														>
															{`${comment.userName} at ${moment(comment.creationTimestamp).format('DD-MM-YYYY HH:mm:ss').toString()}`}
														</Typography>
													</>
												)}
												secondary={(
													<>
														<Typography
															component="span"
															variant="body2"
															color="textPrimary"
															style={{ marginLeft: '5%' }}
														>
															{comment.comment}
														</Typography>
													</>
												)}
											/>
										</ListItem>
										<Divider component="li" />
									</>
								)) : (
									<>
										<ListItem alignItems="flex-start">
											<ListItemText
												secondary={(
													<>
														<Typography
															component="span"
															variant="body2"
															color="textPrimary"
															style={{ marginLeft: '5%' }}
														>
															No comments added
														</Typography>
													</>
												)}
											/>
										</ListItem>
									</>
								)}
							</List>
						)}
					</Grid>
				</Grid>
			</CardContent>
			<Divider />
			<CardActions>
				<Paper className={classes.paper} elevation={1}>
					<Input
						value={commentValue}
						className={classes.input}
						disableUnderline
						onChange={_handleCommentInputChange}
						placeholder="Type a comment"
					/>
				</Paper>
				<Tooltip title="Post">
					<IconButton
						color={commentValue.length > 0 ? 'primary' : 'default'}
						disabled={!commentValue.length > 0}
						onClick={_postComment}
						size="large"
					>
						<SendIcon />
					</IconButton>
				</Tooltip>
			</CardActions>
		</Card>
	);
};

Comments.propTypes = {
	className: PropTypes.object,
	ticketId: PropTypes.number,
	comments: PropTypes.array
};

export default Comments;
